import React, { useEffect, useState, useCallback } from "react";
import InvoiceList from "./InvoiceList";
import InvoiceEditModal from "./InvoiceEditModal";
import api from "../../api";
import { useTranslation } from "react-i18next";
import { FaFileInvoice } from "react-icons/fa";

const InvoicesPage = () => {
  const { t } = useTranslation();
  const [invoices, setInvoices] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchInvoices = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/invoices");
      setInvoices(res.data?.data || []);
    } catch (err) {
      alert(t("invoice.loadError"));
    }
    setLoading(false);
  }, [t]);

  useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);

  const handleEdit = (invoice = null) => {
    setSelectedInvoice(invoice);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedInvoice(null);
    fetchInvoices();
  };

  return (
    <div className="max-w-5xl mx-auto py-6 px-4 md:px-8">
      {/* Page header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
            <FaFileInvoice className="text-lg" />
          </div>
          <div>
            <h1 className="text-2xl font-extrabold tracking-tight text-base-content">
              {t("invoice.management")}
            </h1>
            <p className="text-sm text-base-content/40 mt-0.5">
              {invoices.length} facture{invoices.length !== 1 ? "s" : ""}
            </p>
          </div>
        </div>
        <button
          onClick={() => handleEdit(null)}
          className="btn btn-primary gap-2"
        >
          <span className="text-base font-bold leading-none">+</span>
          {t("invoice.add")}
        </button>
      </div>

      {/* Content card */}
      <div className="bg-base-100 rounded-2xl border border-base-200 shadow-sm p-4 md:p-6">
        {loading ? (
          <div className="flex items-center gap-3 text-base-content/40 py-10 justify-center">
            <span className="loading loading-spinner loading-sm text-primary" />
            <span className="text-sm font-medium">{t("invoice.loading")}</span>
          </div>
        ) : (
          <InvoiceList invoices={invoices} onEdit={handleEdit} refresh={fetchInvoices} />
        )}
      </div>

      <InvoiceEditModal
        open={modalOpen}
        onClose={handleCloseModal}
        invoice={selectedInvoice}
      />
    </div>
  );
};

export default InvoicesPage;
